/**
 * How this device must print the chef packet.
 *
 * iPhone and iPad (every browser there is WebKit, printing through UIKit)
 * cannot print a long page whole: UIKit keeps the page count of its first
 * pagination pass and draws only that many pages. They get the packet as a
 * finished PDF through the share sheet (`pdf-share-sheet.ts`). Desktop
 * browsers and Android paginate once, so they print the page itself.
 */

/**
 * True on iPhone, iPod and iPad. iPadOS asks for desktop sites by default and
 * reports a Mac user agent; its touch points tell it apart (Macs report 0).
 */
export function isAppleTouchDevice(
  nav: Pick<Navigator, 'userAgent' | 'maxTouchPoints'> | undefined = globalThis.navigator,
): boolean {
  if (!nav) {
    return false
  }
  return /\b(iPhone|iPod|iPad)\b/.test(nav.userAgent) || (/\bMacintosh\b/.test(nav.userAgent) && nav.maxTouchPoints > 1)
}

const ASSET_STYLESHEET_HREF = /^\/assets\/[\w.-]+\.css$/

/**
 * The hashed stylesheet this page loaded (`/assets/index-<hash>.css`), sent
 * with a print so the server can refuse markup from an older bundle than its
 * own stylesheet. Null under the Vite dev server, which injects styles instead.
 */
export function clientStylesheetHref(
  doc: Pick<Document, 'querySelectorAll'> | undefined = globalThis.document,
): string | null {
  if (!doc) {
    return null
  }
  for (const link of Array.from(doc.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]'))) {
    const href = link.getAttribute('href')
    if (href && ASSET_STYLESHEET_HREF.test(href)) {
      return href
    }
  }
  return null
}
